'use strict';

// Import Libraries
import React from 'react';
import PropTypes from 'prop-types';

// Import JS Modules
import translate from '../_utils/tools/translate';

// -----------------------------------------------------------
//  ClearFilters
// -----------------------------------------------------------
const ClearFilters = ({onClearAllFiltersClick}) => {
  const handleCollapsedClicked = () => onClearAllFiltersClick();
  return (
    <li className="m-1">
      <a onClick={handleCollapsedClicked} className="clear-filter-menu" tabIndex="0">
        {translate('Clear all')}
      </a>
    </li>
  );
};

ClearFilters.propTypese = {
  onClearAllFiltersClick: PropTypes.func
}

export default ClearFilters;
